import React, { useEffect, useState } from 'react';
import { getDailyFailureRate } from '../../../../../../../services/api';
import { convertProjectData } from '../../../../../../../services/utils/utils';
import BibliothequePlotly from '../../../../../../Graphe/AffichageGraphe/BibliothequePlotly/BibliothequePlotly';
const layout = {
  title: 'Taux de pannes par jour ',
  xaxis: {
    tickformat: '%d %b %Y',
    tickmode: 'linear',
    dtick: 86400000,
  },
  yaxis: {
    title: 'Taux de pannes [%]',
  },
};
const GrapheTauxDePannes = (props: any) => {
  const [graphData, setGraphData] = useState<any>();

  useEffect(() => {
    const getGraphData = async () => {
      const graphDataResponse = await getDailyFailureRate({
        ...props,
      });
      if (graphDataResponse?.data.state) {
        setGraphData(graphDataResponse.data);
      }
    };
    getGraphData();
  }, [props]);

  return (
    <>
      {graphData?.projects_list?.length > 0 && (
        <BibliothequePlotly
          data={convertProjectData(graphData.projects_list)}
          layout={layout}
          modeBar={true}
        />
      )}
    </>
  );
};

export default GrapheTauxDePannes;
